import { UserRole } from '../../../../api/types/backend-dto-types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../components/atoms/ShadCnSelect';
import { useUserContext } from '../../../../Contexts/User';

interface Props {
  role: UserRole;
  roles: UserRole[];
  updateRole: (roleId: string) => void;
}

export const RoleSelect = ({ role, roles, updateRole }: Props) => {
  const { user } = useUserContext();

  return (
    <Select value={role.id} onValueChange={updateRole}>
      <SelectTrigger className="w-40">
        <SelectValue placeholder="" />
      </SelectTrigger>
      <SelectContent>
        {roles
          .filter((r) => r.name !== 'Administrator' || user?.organisation.isGlobalAdmin === true)
          .map((roleItem) => (
            <SelectItem key={roleItem.id} value={roleItem.id}>
              {roleItem.name}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};
